"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.updateValidation = exports.registerDisabled = exports.registerFailure = exports.registerSuccess = exports.registerRequest = void 0;
const actionTypes = require("../../actionTypes/register");
const registerRequest = (link, email) => ({
    type: actionTypes.REGISTER_REQUEST,
    payload: {
        link,
        email
    }
});
exports.registerRequest = registerRequest;
const registerSuccess = () => ({
    type: actionTypes.REGISTER_SUCCESS
});
exports.registerSuccess = registerSuccess;
const registerFailure = (error) => ({
    type: actionTypes.REGISTER_FAILURE,
    payload: error
});
exports.registerFailure = registerFailure;
const registerDisabled = (status) => ({
    type: actionTypes.REGISTER_DISABLED,
    payload: {
        status
    }
});
exports.registerDisabled = registerDisabled;
function updateValidation(payload) {
    return {
        type: actionTypes.UPDATE_VALIDATION,
        payload
    };
}
exports.updateValidation = updateValidation;
const clear = () => ({
    type: actionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=index.js.map